import React from "react";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page" className="max-w-4xl mx-auto px-6 py-20 lg:py-28 text-white">
      <div className="label-eyebrow mb-4 text-hgold">Legal Document</div>
      <h1 className="text-4xl lg:text-5xl font-heading mb-8">Privacy Policy</h1>
      
      <div className="space-y-6 text-sm text-hsecondary leading-relaxed font-light">
        <p><strong>Effective Date:</strong> July 29, 2026</p>
        
        <p>
          At <strong>Hammam Mens Spa</strong>, accessible from our website and management portals, one of our main priorities is the privacy of our visitors and guests. This Privacy Policy document contains types of information that is collected and recorded by Hammam Mens Spa and how we use it.
        </p>

        <h2 className="text-xl font-heading text-hgold pt-6 font-semibold">1. Information We Collect</h2>
        <p>
          We collect personal information that you voluntarily provide to us when registering, booking a session, or contacting us. This includes:
        </p>
        <ul className="list-disc pl-6 space-y-1 text-white/95">
          <li>Personal identification information (Name, Email Address, Phone Number).</li>
          <li>Location details for doorstep service bookings.</li>
          <li>Billing and transaction information processed securely through our payment gateways (e.g. Cashfree).</li>
          <li>Feedback, inquiries, and customer support messages.</li>
        </ul>

        <h2 className="text-xl font-heading text-hgold pt-6 font-semibold">2. How We Use Your Information</h2>
        <p>
          We use the information we collect in various ways, including to:
        </p>
        <ul className="list-disc pl-6 space-y-1 text-white/95">
          <li>Provide, operate, and maintain our booking services (both In-Spa and Doorstep).</li>
          <li>Process transactions and send invoices or confirmation emails.</li>
          <li>Manage wallet credits, memberships, and loyalty points.</li>
          <li>Communicate with you regarding bookings, appointments, and support requests.</li>
          <li>Ensure safety, hygiene, and verify customer identities to maintain a secure environment.</li>
        </ul>

        <h2 className="text-xl font-heading text-hgold pt-6 font-semibold">3. Discretion & Confidentiality</h2>
        <p>
          Given the specialized nature of our spa therapies, absolute discretion is a core values at Hammam. We do not sell, rent, or share guest data with third-party advertising companies. Your records, preferences, and visits are strictly confidential between you and the management.
        </p>

        <h2 className="text-xl font-heading text-hgold pt-6 font-semibold">4. Payment Processing (Cashfree API)</h2>
        <p>
          All online card, net banking, UPI, and wallet payments are securely routed through <strong>Cashfree Payments</strong>. Hammam Mens Spa does not store your complete card numbers or internet banking credentials on our servers. All transactions comply with PCI-DSS guidelines.
        </p>

        <h2 className="text-xl font-heading text-hgold pt-6 font-semibold">5. Cookies and Web Beacons</h2>
        <p>
          Like any other website, Hammam Mens Spa uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.
        </p>

        <h2 className="text-xl font-heading text-hgold pt-6 font-semibold">6. Data Security</h2>
        <p>
          We implement a variety of security measures to maintain the safety of your personal information when you place a booking or enter, submit, or access your personal info. However, no method of transmission over the Internet is 100% secure.
        </p>

        <h2 className="text-xl font-heading text-hgold pt-6 font-semibold">7. Contact Us</h2>
        <p>
          If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us at:
          <br />
          <strong>Email:</strong> info.hammammensspa@gmail.com
          <br />
          <strong>Contact Support:</strong> +91 9560656913
        </p>
      </div>
    </div>
  );
}
